import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export default function AllChinaBuyShipping() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-stone-50">
      <Navbar />
      <div className="pt-20 pb-4 bg-white border-b border-stone-100">
        <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
          <nav className="flex items-center gap-2 text-sm text-stone-500">
            <Link to="/" className="hover:text-stone-900 transition-colors cursor-pointer">{t('breadcrumb_home')}</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-stone-900 font-medium">AllChinaBuy Shipping Cost</span>
          </nav>
        </div>
      </div>
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12 py-8 md:py-12">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-2xl border border-stone-200 p-6 md:p-10 shadow-sm">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-stone-100 rounded-full text-stone-600 mb-4">10 min read</span>
            <h1 className="text-2xl md:text-3xl font-bold text-stone-900 mb-4">AllChinaBuy Shipping Cost: Complete Guide to Rates &amp; Savings</h1>
            <div className="flex items-center gap-4 text-sm text-stone-500 mb-6">
              <span>{t('article_last_updated')}: August 25, 2026</span>
              <span>{t('article_author')}: AllChinaBuy Research Team</span>
            </div>

            <p className="text-stone-600 leading-relaxed mb-4">
              Understanding <strong>AllChinaBuy shipping costs</strong> is essential for budgeting your international purchases. This guide breaks down shipping methods, cost factors, and money-saving strategies.
            </p>

            <h2 className="text-xl font-bold text-stone-900 mt-8 mb-3">Shipping Methods Available</h2>
            <p className="text-stone-600 leading-relaxed mb-4">
              AllChinaBuy offers several shipping options to accommodate different needs and budgets. The available methods vary by destination country and package characteristics.
            </p>
            <ul className="space-y-2 mb-4">
              <li className="flex items-start gap-2 text-stone-600"><i className="ri-check-line text-emerald-500 mt-1"></i><span><strong>EMS:</strong> Reliable postal service with tracking, typically 7-20 days</span></li>
              <li className="flex items-start gap-2 text-stone-600"><i className="ri-check-line text-emerald-500 mt-1"></i><span><strong>DHL/FedEx:</strong> Express courier, 3-10 days, higher cost</span></li>
              <li className="flex items-start gap-2 text-stone-600"><i className="ri-check-line text-emerald-500 mt-1"></i><span><strong>E-Packet:</strong> Budget option for small packages, 15-30 days</span></li>
              <li className="flex items-start gap-2 text-stone-600"><i className="ri-check-line text-emerald-500 mt-1"></i><span><strong>Special Lines:</strong> Country-specific budget options</span></li>
            </ul>

            <h2 className="text-xl font-bold text-stone-900 mt-8 mb-3">What Affects Shipping Cost?</h2>
            <div className="bg-stone-50 rounded-xl p-5 mb-4">
              <ul className="space-y-2 text-sm text-stone-600">
                <li><strong>Package Weight:</strong> Heavier items cost more to ship</li>
                <li><strong>Volumetric Weight:</strong> Large but light items may be charged by dimensions</li>
                <li><strong>Destination:</strong> Shipping to remote areas costs more</li>
                <li><strong>Insurance:</strong> Optional declared value coverage</li>
                <li><strong>Customs:</strong> Import duties may apply in your country</li>
              </ul>
            </div>

            <h2 className="text-xl font-bold text-stone-900 mt-8 mb-3">Tips to Reduce Shipping Costs</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
              <div className="bg-white border border-stone-200 rounded-xl p-4">
                <h4 className="font-semibold text-stone-900 text-sm mb-1">Consolidate Packages</h4>
                <p className="text-sm text-stone-600">Combine multiple items into one shipment to reduce per-item costs.</p>
              </div>
              <div className="bg-white border border-stone-200 rounded-xl p-4">
                <h4 className="font-semibold text-stone-900 text-sm mb-1">Remove Packaging</h4>
                <p className="text-sm text-stone-600">Request removal of shoe boxes and excess packaging to reduce weight.</p>
              </div>
              <div className="bg-white border border-stone-200 rounded-xl p-4">
                <h4 className="font-semibold text-stone-900 text-sm mb-1">Choose Economy Lines</h4>
                <p className="text-sm text-stone-600">Budget shipping lines are slower but significantly cheaper.</p>
              </div>
              <div className="bg-white border border-stone-200 rounded-xl p-4">
                <h4 className="font-semibold text-stone-900 text-sm mb-1">Check Customs Limits</h4>
                <p className="text-sm text-stone-600">Stay under your country's tax-free threshold to avoid duties.</p>
              </div>
            </div>

            <div className="mt-8 bg-stone-900 rounded-xl p-6 text-center">
              <p className="text-white mb-4">Ready to shop smarter?</p>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-2.5 bg-white text-stone-900 rounded-lg text-sm font-medium hover:bg-stone-100 transition-colors cursor-pointer">
                AllChinaBuy Spreadsheet <i className="ri-external-link-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}